import { Component, Input, OnInit } from '@angular/core';
import { TestsService } from '../../course/services/tests.service';
import { FaaTestResult } from 'src/app/course/tests/faa-test-report/faaTestResult-model';
import { TestBuilderService } from 'src/app/course/services/test-builder.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-acs-session',
  templateUrl: './acs-session.component.html',
  styleUrls: ['./acs-session.component.scss']
})
export class AcsSessionComponent implements OnInit {

  @Input()
  test: FaaTestResult;

  @Input()
  course: any;

  @Input()
  user: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private testBuilderService: TestBuilderService,
    public testsService: TestsService
  ) {
  }

  ngOnInit(): void {
  }

  viewTest(url: string) {
    window.open(url, '_blank');
  }

  async startTest(testId: number) {
    this.testBuilderService.startFaaTest(testId).then(value => {
      const response = value as any;
      this.router.navigate(['../', response.testResult.testType.toLowerCase()], { relativeTo: this.route.parent });
    });
  }

}
